module.exports = __webpack_public_path__ + "assets/icons/ic_undo-bdba.svg";